import React from 'react';
import sprintf from 'sprintf';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMAprilfoolPopupView from 'components/others/SMAprilfoolPopupView';

class SMAprilfoolView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isPopupViewOpen: false,
            twitterUrl: '#',
            facebookUrl: '#',
            pocketUrl: '#',
            url: '#',
        };
        this.showPopupView = this.showPopupView.bind(this);
    }

    componentDidMount() {
        setTimeout(this.setSocialLinks.bind(this), 10);
    };

    setSocialLinks() {
        const url = this.props.aprilfoolUrl;
        const title = '宇宙空間の貸し借りなら「スペースマーケット」';
        const twitterUrl = sprintf(
          'https://twitter.com/intent/tweet?url=%s&amp;text=%s',
          url,
          encodeURIComponent(title),
         );
        const facebookUrl = sprintf(
          'https://www.facebook.com/sharer/sharer.php?u=%s',
           url,
         );
        const pocketUrl = sprintf(
          'http://getpocket.com/edit?url=%s',
          url,
        );

        this.setState({
          twitterUrl: twitterUrl,
          facebookUrl: facebookUrl,
          pocketUrl: pocketUrl,
          url: url,
        });
    }

    showPopupView() {
        this.setState({isPopupViewOpen: true});
    }

    aprilfoolPopupViewDidClose() {
        this.setState({isPopupViewOpen: false});
    }

    renderHeroImages() {
      return(
        <div id="slider" className="flexslider">
          <div ref="slider" className="top-slider__cover">
            <img src={SMRailsBridge.assetPath.aprilfool2017Category01} alt="" className="mod-heroimg__img aprilfool2017__heroimg-img" />
              <div className="mod-heroimg aprilfool2017__heroimg">

                  <div className="mod-heroimg__bg aprilfool2017__heroimg-bg">
                      <h1 className="mod-heroimg__title static-heroimg__title aprilfool2017__heroimg-title">
                          <span className="aprilfool2017__heroimg-subtitle">今度はここで 何しよう</span>SPACE MARKET</h1>
                  </div>
              </div>
          </div>

          <div className="mod-heroimg aprilfool2017__heroimg">
              <div className="top-slider__position">
              </div>
          </div>
        </div>
      );
    }

    render() {
        return (
            <div className="site-main">
                {this.renderHeroImages()}

                <div className="page__even page__padding-mb0">
                    <div className="container">
                        <h2 className="aprilfool2017__title">スペースの貸し借りを簡単に</h2>
                        <div className="row aprilfool2017__flow">
                            <div className="col-xs-6 col-md-3">
                                <div className="aprilfool2017__flow__step-1 aprilfool2017__flow__step">
                                    <img src={SMRailsBridge.assetPath.aprilfool2017Step01} className="aprilfool2017__flow__step-img" alt="" />
                                    <h3 className="aprilfool2017__flow__step-title">スペースを探す</h3>
                                    <p>エリアや目的などから<br />利用したいスペースを<br />探します。</p>
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="aprilfool2017__flow__step-2 aprilfool2017__flow__step">
                                    <img src={SMRailsBridge.assetPath.aprilfool2017Step02} className="aprilfool2017__flow__step-img" alt="" />
                                    <h3 className="aprilfool2017__flow__step-title">予約リクエスト</h3>
                                    <p>予約したい日程を選んで<br />ホストとメッセージの<br />やりとりを行います。</p>
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="aprilfool2017__flow__step-3 aprilfool2017__flow__step">
                                    <img src={SMRailsBridge.assetPath.aprilfool2017Step03} className="aprilfool2017__flow__step-img" alt="" />
                                    <h3 className="aprilfool2017__flow__step-title">予約可否</h3>
                                    <p>ホストの承認後、予約成立。<br />利用時間に間に合うよう<br />スペースへお越しください。</p>
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="aprilfool2017__flow__step-4 aprilfool2017__flow__step">
                                    <img src={SMRailsBridge.assetPath.aprilfool2017Step04} className="aprilfool2017__flow__step-img" alt="" />
                                    <h3 className="aprilfool2017__flow__step-title">決済・利用</h3>
                                    <p>決済は現地通貨で。<br />隕石を避けながら<br />利用をお楽しみください。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page__odd page__padding">
                    <div className="container">
                        <h2 className="aprilfool2017__title">条件から探す</h2>
                        <p className="aprilfool2017__title-content">あなたの用途に合わせて、さまざまな条件からスペースを探すことができます。</p>
                        <div className="row aprilfool2017__category">
                            <div className="col-sm-12 col-md-4">
                                <div className="aprilfool2017__category__image">
                                    <a href="#" onClick={this.showPopupView}><img src={SMRailsBridge.assetPath.aprilfool2017Category01} alt="" className="aprilfool2017__category__image-pict" />
                                        <div className="aprilfool2017__category__image-bg">
                                            <h3 className="aprilfool2017__category__title">アクセス<span className="aprilfool2017__category__title-sub">で探す</span>
                                            </h3>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="aprilfool2017__category__image">
                                    <a href="#" onClick={this.showPopupView}><img src={SMRailsBridge.assetPath.aprilfool2017Category02} alt="" className="aprilfool2017__category__image-pict" />
                                        <div className="aprilfool2017__category__image-bg">
                                            <h3 className="aprilfool2017__category__title">直径<span className="aprilfool2017__category__title-sub">から探す</span>
                                            </h3>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="aprilfool2017__category__image">
                                    <a href="#" onClick={this.showPopupView}><img src={SMRailsBridge.assetPath.aprilfool2017Category03} alt="" className="aprilfool2017__category__image-pict" />
                                        <div className="aprilfool2017__category__image-bg">
                                            <h3 className="aprilfool2017__category__title">表面温度<span className="aprilfool2017__category__title-sub">から探す</span>
                                            </h3>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page__even page__padding">
                    <div className="container">
                        <h2 className="aprilfool2017__title">スタッフのおすすめまとめ</h2>
                        <p className="aprilfool2017__title-content">スタッフいちおしのスペースまとめを紹介しています。ここから探せば絶対ハズレなし！</p>
                        <div className="row">
                            <div className="col-sm-12 col-md-4 aprilfool2017__matome-box">
                                <a href="#">
                                    <div className="aprilfool2017__matome-linkbox">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Matome01} alt="" className="is-hover" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__matome-title">格安のスペースまとめ</h3>
                                    </div>
                                </a>
                                <p className="aprilfool2017__matome-description">格安で借りることができ、レビューも高評価のスペースをまとめました。コスパ抜群、かつオシャレなスペースがいっぱい！</p>
                            </div>
                            <div className="col-sm-12 col-md-4 aprilfool2017__matome-box">
                                <a href="#">
                                    <div className="aprilfool2017__matome-linkbox">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Matome02} alt="" className="is-hover" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__matome-title">足で立てるスペースまとめ</h3>
                                    </div>
                                </a>
                                <p className="aprilfool2017__matome-description">立食パーティをするなら足で立ちたいですよね。地面が水の中だったり、ぐらぐらしていると落ち着いて話もできません。地面のしっかりしたスペースをまとめました!
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-4 aprilfool2017__matome-box">
                                <a href="#">
                                    <div className="aprilfool2017__matome-linkbox">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Matome03} alt="" className="is-hover" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__matome-title">水のあるスペースまとめ</h3>
                                    </div>
                                </a>
                                <p className="aprilfool2017__matome-description">パーティをするならやっぱり水は絶対必要！水があってはじめて乾杯ができるってものですよね。そんなパーティに最適なスペースをまとめました。</p>
                            </div>
                        </div>
                        <div className="aprilfool2017__more">
                            <a href="#" className="button-blue aprilfool2017__more-button" onClick={this.showPopupView}>スタッフのおすすめまとめをもっと見る</a>
                        </div>
                    </div>
                </div>

                <div className="page__odd page__padding">
                    <div className="container">
                        <h2 className="aprilfool2017__title">開催中のキャンペーン</h2>
                        <p className="aprilfool2017__title-content">おトクなキャンペーン中のスペースです！このチャンスをお見逃しなく！</p>
                        <div className="row">
                            <div className="col-sm-12 col-md-4 aprilfool2017__campaign-box">
                                <a href="#">
                                    <div className="aprilfool2017__campaign-linkbox is-hover">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Campaign01} alt="" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__campaign-title">最近公開されたスペース限定！<br />利用料3,000円OFF！</h3>
                                        <p className="aprilfool2017__campaign-terms">2017年4月1日〜2017年4月1日</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-sm-12 col-md-4 aprilfool2017__campaign-box">
                                <a href="#">
                                    <div className="aprilfool2017__campaign-linkbox is-hover">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Campaign02} alt="" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__campaign-title">歓送迎会におすすめ！<br />キッチンつきのスペースが10%OFF！</h3>
                                        <p className="aprilfool2017__campaign-terms">2017年4月1日〜2017年4月1日</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-sm-12 col-md-4 aprilfool2017__campaign-box">
                                <a href="#">
                                    <div className="aprilfool2017__campaign-linkbox is-hover">
                                        <img src={SMRailsBridge.assetPath.aprilfool2017Campaign03} alt="" onClick={this.showPopupView} />
                                        <h3 className="aprilfool2017__campaign-title">経営会議や社員研修に！<br />Wi-Fi使用可能なスペースが3,000円OFF！</h3>
                                        <p className="aprilfool2017__campaign-terms">2017年4月1日〜2017年4月1日</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="aprilfool2017__more">
                            <a href="#" className="button-blue aprilfool2017__more-button" onClick={this.showPopupView}>キャンペーンをもっと見る</a>
                        </div>
                    </div>
                </div>

                <div className="page__even page__padding">
                    <div className="container">
                        <h2 className="aprilfool2017__title">人気のスペース</h2>
                        <p className="aprilfool2017__title-content">皆さんからたくさん利用されている、人気のスペースをランキングで紹介します。</p>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <a href="#" className="a__aprilfool2017__units" onClick={this.showPopupView}>
                                    <div className="aprilfool2017__units">
                                        <div className="aprilfool2017__units-image aprilfool2017__units-image-col__h6">
                                            <div className="units-ranking__no1 units-ranking units-ranking__icon">
                                                <div className="units-ranking__icon-body">
                                                    <span className="units-ranking__icon-number">1</span>
                                                </div>
                                            </div>
                                            <img src={SMRailsBridge.assetPath.aprilfool2017Ranking01} alt="" className="aprilfool2017__units-image-pict" />
                                            <p className="aprilfool2017__units-item-price">¥500,000,000<span className="aprilfool2017__units-item-per">/時間</span>
                                            </p>
                                        </div>
                                        <div className="aprilfool2017__units-body">
                                            <div className="aprilfool2017__units-body-inner link__subcolor">
                                                <h3 className="aprilfool2017__units-body-title">【世界の終わり】リアル脱出ゲームならここで決まり。つまらない日常から脱出したい人におすすめ</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <a href="#" className="a__aprilfool2017__units" onClick={this.showPopupView}>
                                            <div className="aprilfool2017__units">
                                                <div className="aprilfool2017__units-image">
                                                    <div className="units-ranking__no2 units-ranking units-ranking__icon">
                                                        <div className="units-ranking__icon-body">
                                                            <span className="units-ranking__icon-number">2</span>
                                                        </div>
                                                    </div>
                                                    <img src={SMRailsBridge.assetPath.aprilfool2017Ranking02} alt="" className="aprilfool2017__units-image-pict" />
                                                    <p className="aprilfool2017__units-item-price">¥900,000,000,000<span className="aprilfool2017__units-item-per">/時間</span>
                                                    </p>
                                                </div>
                                                <div className="aprilfool2017__units-body">
                                                    <div className="aprilfool2017__units-body-inner link__subcolor">
                                                        <h3 className="aprilfool2017__units-body-title">【ロマンティックが止まらない】銀河丸ごと貸切！銀河の中心から愛を叫ぼう</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <a href="#" className="a__aprilfool2017__units" onClick={this.showPopupView}>
                                            <div className="aprilfool2017__units">
                                                <div className="aprilfool2017__units-image">
                                                    <div className="units-ranking__no3 units-ranking units-ranking__icon">
                                                        <div className="units-ranking__icon-body">
                                                            <span className="units-ranking__icon-number">3</span>
                                                        </div>
                                                    </div>
                                                    <img src={SMRailsBridge.assetPath.aprilfool2017Ranking03} alt="" className="aprilfool2017__units-image-pict" />
                                                    <p className="aprilfool2017__units-item-price">¥80,000,000,000<span className="aprilfool2017__units-item-per">/時間</span>
                                                    </p>
                                                </div>
                                                <div className="aprilfool2017__units-body">
                                                    <div className="aprilfool2017__units-body-inner link__subcolor">
                                                        <h3 className="aprilfool2017__units-body-title">【BBQに最適】火おこし不要！手ぶらでBBQはいかが？</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <a href="#" className="a__aprilfool2017__units" onClick={this.showPopupView}>
                                            <div className="aprilfool2017__units">
                                                <div className="aprilfool2017__units-image">
                                                    <div className="units-ranking__non units-ranking units-ranking__icon">
                                                        <div className="units-ranking__icon-body">
                                                            <span className="units-ranking__icon-number">4</span>
                                                        </div>
                                                    </div>
                                                    <img src={SMRailsBridge.assetPath.aprilfool2017Ranking04} alt="" className="aprilfool2017__units-image-pict" />
                                                    <p className="aprilfool2017__units-item-price">¥700,000,000,000<span className="aprilfool2017__units-item-per">/時間</span>
                                                    </p>
                                                </div>
                                                <div className="aprilfool2017__units-body">
                                                    <div className="aprilfool2017__units-body-inner link__subcolor">
                                                        <h3 className="aprilfool2017__units-body-title">【1日が地球の243倍】とことん話し合いたい時に。1day合宿や、研修におすすめ！</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <a href="#" className="a__aprilfool2017__units" onClick={this.showPopupView}>
                                            <div className="aprilfool2017__units">
                                                <div className="aprilfool2017__units-image">
                                                    <div className="units-ranking__non units-ranking units-ranking__icon">
                                                        <div className="units-ranking__icon-body">
                                                            <span className="units-ranking__icon-number">5</span>
                                                        </div>
                                                    </div>
                                                    <img src={SMRailsBridge.assetPath.aprilfool2017Ranking05} alt="" className="aprilfool2017__units-image-pict" />
                                                    <p className="aprilfool2017__units-item-price">¥80,000,000,000<span className="aprilfool2017__units-item-per">/時間</span>
                                                    </p>
                                                </div>
                                                <div className="aprilfool2017__units-body">
                                                    <div className="aprilfool2017__units-body-inner link__subcolor">
                                                        <h3 className="aprilfool2017__units-body-title">【渋谷駅から4日位】歴史に残る名言を持ってる人に！あなたの発言に世界が注目</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="aprilfool2017__more">
                            <a href="#" className="button-blue aprilfool2017__more-button" onClick={this.showPopupView}>ランキングをもっと見る</a>
                        </div>
                    </div>
                </div>

                <div className="mod-banner mod-banner__guest aprilfool2017__footer">
                    <div className="container">
                        <h3>今すぐ宇宙に行けない方はこちら</h3>
                        <p>地球上のスペースもたくさんご用意しています。今すぐ宇宙に行けない方は、まずは地球のスペースを借りてみましょう。</p>
                        <a href="https://spacemarket.com" className="mod-banner__button aprilfool2017__footer-button">地球のスペースを借りる</a>
                        <h4 className="aprilfool2017__share-title">宇宙に行きたくなったらシェア！</h4>
                        <ul className="row aprilfool2017__social">
                            <li className="col-xs-6 col-md-3 sm-mb10">
                                <a href={this.state.twitterUrl} target="_blank" className=" aprilfool2017__social-twitter">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </li>
                            <li className="col-xs-6 col-md-3 sm-mb10">
                                <a href={this.state.facebookUrl} target="_blank" className="aprilfool2017__social-facebook">
                                    <i className="fa fa-facebook-square"></i>
                                </a>
                            </li>
                            <li className="col-xs-6 col-md-3">
                                <a href={this.state.pocketUrl} target="_blank" className="aprilfool2017__social-pocket">
                                    <i className="fa fa-get-pocket"></i>
                                </a>
                            </li>
                            <li className="col-xs-6 col-md-3">
                                <div className="aprilfool2017__social-like">
                                    <div className="fb-like" data-href={this.state.url} data-layout="button_count" data-action="like" data-show-faces="true" data-share="false"></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <a href="https://spacemarket.com" className="aprilfool2017__banner-spm">
                        地球の<br />スペースを<br />借りるなら
                        <img src={SMRailsBridge.assetPath.spaceMarketLogoMark} className="aprilfool2017__banner-spm-icon" alt="SPACEMARKET" />
                    </a>
                </div>

                <SMAprilfoolPopupView
                  delegate={this}
                  twitterUrl={this.state.twitterUrl}
                  facebookUrl={this.state.facebookUrl}
                  pocketUrl={this.state.pocketUrl}
                  url={this.state.url}
                  isOpen={this.state.isPopupViewOpen}
                />

            </div>
        );
    };
}

export default SMAprilfoolView;



// WEBPACK FOOTER //
// ./app/javascript/components/others/SMAprilfoolView.jsx